import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filter } from 'rxjs/operators';
import styled from 'styled-components';

import { ComposedActions } from '../../../helpers/actions';
import ActionService from '../../../store/actions.service';
import { colors } from '../WindowConfig';
import DataCell from './common/DataCell';

export interface IAlertAreaProps {}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const AlertHeader = styled.div`
  display: flex;
  justify-content: space-around;
  background-color: rgb(33, 43, 71);
`;
const AlertList = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.secondary};
  height: 85px;
  overflow-y: auto;
`;

const AlertButton = styled.button`
  background-color: ${colors.primary};
  color: ${colors.yellowText};
  padding: 8px 20px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;
const AlertItem = styled.div<any>`
  color: ${({ fontColor }) => fontColor || 'inherit'};
  width: 100%;
  height: 20px;
  padding: 4px 5px;
  border-bottom: solid 1px ${colors.border};
`;

export default function AlertArea(props: IAlertAreaProps) {
  const executor = useSelector((state: any) => state.executor);
  const { alerts } = executor;
  const dispatch = useDispatch();
  const audioRef = useRef(null);

  useEffect(() => {
    const subscription = ActionService.getActions()
      .pipe(filter((action: any) => action.type === 'ShowAlert'))
      .subscribe(() => {
        playSound();
      });

    return () => {
      subscription?.unsubscribe();
    };
  });

  const playSound = () => {
    if (executor.playAlertSound && audioRef.current !== null) {
      (audioRef?.current as any).play();
    }
  };

  const handleClick = (id: string) => {
    dispatch(
      ComposedActions.ClickButtonOnReviewAlertsPanel.aCreator({
        id,
      })
    );
  };
  return (
    <Container>
      <AlertHeader>
        <p>Alerts</p>
        <DataCell height="25px" padding="5px 5px" margin="10px 0 0 0">
          {alerts.length}
        </DataCell>
        <AlertButton
          onClick={() => handleClick('RAP_alerts_review_button')}
          id="RAP_alerts_review_button"
        >
          Alert Review
        </AlertButton>
        <AlertButton
          onClick={() => handleClick('RAP_sound_off_button')}
          id="RAP_sound_off_button"
        >
          Sound {executor.playAlertSound ? 'OFF' : 'ON'}
        </AlertButton>
        <AlertButton
          onClick={() => handleClick('RAP_expand_button')}
          id="RAP_expand_button"
        >
          Expand
        </AlertButton>
      </AlertHeader>
      <AlertList>
        {alerts.map((a: any) => (
          <AlertItem key={a.title} fontColor={a.fontColor}>
            {a.title}
          </AlertItem>
        ))}
      </AlertList>
      <audio
        ref={audioRef}
        src={require('../../../assets/audio/click.mp3')}
      ></audio>
    </Container>
  );
}
